// Export the Component Definition for use in Contentful Studio
export {DividerContentfulComponentDefinition} from './dividerContentfulDefinition';
export type {DividerProps} from './Divider';
export {default} from './Divider';
